<template>
  <section class="spacesGuidelines">
    <div class="mb-3">Follow these guidelines when editing to ensure formatting is correct:</div>
    <div>
      <ul>
        <li>The “RESOURCEID” field is the <strong>unique ID</strong> per space.</li>
        <li>A <strong>new</strong> unique “RESOURCEID” will <strong>create</strong> a new space.</li>
        <li>An existing “RESOURCEID” will <strong>update</strong> that existing space.</li>
        <li>If using the upload functionality prior to integrating calendar systems, ensure the <strong>exact calendar resource ID</strong> is used in the “Space Key” that will be sent via the integration.</li>
        <li>For non-bookable spaces or spaces without a calendar resource ID, input a unique value in the “RESOURCEID” field (recommended to be a number).</li>
        <li>Using the “Building Key” will <strong>associate all building attributes</strong> to that space. Obtain Building Key values by downloading your building csv.</li>
      </ul>
    </div>
  </section>
</template>
<script>
export default {
  name: 'spaces-guidelines',
}
</script>
<style lang="scss" scoped>
</style>
